import { Link, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import React, { useState, useEffect, useRef } from "react";
import { Menu, X, Sun, Moon, Phone, MessageCircle, ChevronDown } from "lucide-react";
import { NavLinksData } from "../../utils/static-data";
import * as CommonActions from "../../redux/actions/commonAction";
import { support_number } from "../../utils/constant";

function Header() {
    const location = useLocation();
    const dispatch = useDispatch();
    const { isScreenScroll } = useSelector(state => state?.commonReducer);
    const navRef = useRef(null);
    const [shownav, setShownav] = useState(false);
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [theme, setTheme] = useState(localStorage.getItem("theme") || "light");

    useEffect(() => {
        if (theme === "dark") { document.documentElement.classList.add("dark"); }
        else { document.documentElement.classList.remove("dark"); }
        localStorage.setItem("theme", theme);
    }, [theme]);

    const toggleTheme = () => setTheme(p => p === "light" ? "dark" : "light");

    useEffect(() => {
        const handleResize = () => { if (window.innerWidth > 500) { setShownav(false); } };
        const handleScroll = () => { dispatch(CommonActions.setScreenScroll(window.scrollY > 10)); };
        window.addEventListener("resize", handleResize);
        document.addEventListener("scroll", handleScroll);
        return () => { window.removeEventListener("resize", handleResize); document.removeEventListener("scroll", handleScroll); };
    }, []);

    return (
        <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScreenScroll ? "bg-[#004d46] shadow-md" : "bg-transparent dark:bg-[#004d46]/95"}`}>
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="flex items-center justify-between h-20">

                    <Link to="/" className="flex items-center gap-2">
                        <span className={`text-xl font-bold transition ${isScreenScroll || location.pathname === "/" ? "text-white" : "text-[#0b3d2e] dark:text-white"} hover:text-[#8bcf6a]`}>Iris Analysis 2.0</span>
                    </Link>

                    <nav className="hidden lg:flex items-center gap-8">
                        {NavLinksData.map(link => (
                            <Link key={link?.name} to={link?.path} className={`flex items-center gap-1 font-medium transition ${isScreenScroll || location.pathname === "/" ? "text-white" : "text-[#0b3d2e] dark:text-white"} hover:text-[#8bcf6a]`}>
                                {link?.name}
                            </Link>
                        ))}
                    </nav>

                    <div className="hidden lg:flex items-center gap-4">
                        <button onClick={toggleTheme} className={`p-2 rounded-full transition ${isScreenScroll || location.pathname === "/" ? "text-white hover:bg-white/10" : "text-[#003b36] dark:text-white hover:bg-black/10 dark:hover:bg-white/10"}`}>
                            {theme === "dark" ? <Sun className="w-5 h-5" /> : <Moon className="w-5 h-5" />}
                        </button>
                    </div>

                    <div className="flex lg:hidden items-center gap-2">
                        <button onClick={toggleTheme} className={`p-2 rounded-full transition ${isScreenScroll || location.pathname === "/" ? "text-white hover:bg-white/10" : "text-[#003b36] dark:text-white hover:bg-black/10 dark:hover:bg-white/10"}`}>
                            {theme === "dark" ? <Sun className="w-5 h-5" /> : <Moon className="w-5 h-5" />}
                        </button>
                        <button onClick={() => setIsMenuOpen(!isMenuOpen)} className={`p-2 rounded-full transition ${isScreenScroll || location.pathname === "/" ? "text-white hover:bg-white/10" : "text-[#003b36] dark:text-white hover:bg-black/10 dark:hover:bg-white/10"}`}>
                            {isMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
                        </button>
                    </div>
                </div>

                {isMenuOpen && (
                    <div className="lg:hidden py-4 bg-[#004d46] border-t border-white/10">
                        <nav className="flex flex-col gap-4">
                            {NavLinksData.map(link => (
                                <Link key={link?.name} to={link?.path} className="text-white/90 hover:text-[#8bcf6a] text-sm" onClick={() => setIsMenuOpen(false)}>
                                    {link?.name}
                                </Link>
                            ))}
                        </nav>
                    </div>
                )}
            </div>
        </header>
    );
}

export default Header;
